import Button from '@/components/base/Button';
import { usePricing } from '../../../hooks/usePricing';

export default function PricingSection() {
  // 💰⚙️の料金設定と自動連動（公開API・失敗時は既定値）
  const pr = usePricing();
  const fmt = (n: number) => n.toLocaleString('ja-JP');
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-4">
          会社の規模に合わせた、分かりやすい料金
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12">すべて税別価格です</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[900px] mx-auto mb-10">
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
            <p className="text-xs text-foreground-500 mb-2">基本料</p>
            <p className="text-3xl font-bold text-foreground-950 mb-1">&yen;{pr.base}</p>
            <p className="text-xs text-foreground-500">月額 / 1社</p>
          </div>
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
            <p className="text-xs text-foreground-500 mb-2">プロジェクト利用料</p>
            <p className="text-3xl font-bold text-foreground-950 mb-1">&yen;{pr.project}</p>
            <p className="text-xs text-foreground-500">月額 / 1プロジェクト</p>
          </div>
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
            <p className="text-xs text-foreground-500 mb-2">ユーザー利用料</p>
            <p className="text-3xl font-bold text-foreground-950 mb-1">&yen;{pr.user}</p>
            <p className="text-xs text-foreground-500">月額 / 1ユーザー</p>
          </div>
        </div>

        <div className="bg-primary-50 rounded-lg p-6 border border-primary-200/70 max-w-[600px] mx-auto mb-10">
          <p className="text-sm font-semibold text-foreground-700 mb-3">料金例：プロジェクト3件、ユーザー10名の場合</p>
          <div className="space-y-2 text-sm text-foreground-600 mb-4">
            <div className="flex justify-between">
              <span>基本料</span>
              <span>&yen;{pr.base}</span>
            </div>
            <div className="flex justify-between">
              <span>プロジェクト利用料（3件 × &yen;{pr.project}）</span>
              <span>&yen;{fmt(3 * pr.projectN)}</span>
            </div>
            <div className="flex justify-between">
              <span>ユーザー利用料（10名 × &yen;{pr.user}）</span>
              <span>&yen;{fmt(10 * pr.userN)}</span>
            </div>
            <div className="flex justify-between font-bold text-foreground-900 pt-2 border-t border-primary-200">
              <span>月額合計（税別）</span>
              <span>&yen;{fmt(pr.baseN + 3 * pr.projectN + 10 * pr.userN)}</span>
            </div>
          </div>
        </div>

        <div className="text-center">
          <Button to="/free-trial/" size="lg" dataCtaName="free_trial" dataCtaLocation="pricing">
            無料で今すぐお試し
          </Button>
        </div>
      </div>
    </section>
  );
}
